<template>
  <Paywall
    :value="[addons, hasComplaintRole]"
    :items="['project:complaint', true]"
    :action="addon"
    :options="{ units: $path('reference.project.metadata.limits.units', item) }"
  >
    <template v-if="!hasComplaintRole && addons.includes('project:complaint')" #content>
      <Alert theme="warning" style="max-width: 500px">
        <div>{{ $t('complaintRoleMissing') }}</div>
        <ButtonComponent
          class="mt-1"
          tag="router-link"
          :label="`${$t('edit')} ${$tc('role', 2).toLowerCase()}`"
          :icon="['fal', 'pen']"
          :to="{ name: 'project-edit', params: { id: $path('reference.project.id', item), step: 'roles' } }"
        />
      </Alert>
    </template>
    <template #default>
      <TaskTable
        v-if="item.id"
        :title="$tc('complaint', 2)"
        :default-filter="{
          search: '',
          type: 'complaint',
          status: ['undone', 'request'],
          reference: `ResidentialAccount:${item.id}`,
        }"
      >
        <template #info>
          <HelperPopover class="ml-1 pull-left" template="complaints-list" />
          <Alert
            v-if="$path('metadata.settings.complaint.blockReceiving', item)"
            class="ml-2"
            theme="warning"
            style="max-width: 500px"
          >
            {{ $t('complaintsBlocked') }}
          </Alert>

          <a v-else href="#" @click.prevent="trigger" class="ml-1">
            {{ $t('createResource', { resource: $tc('complaint').toLowerCase() }) }}</a
          >
        </template>
      </TaskTable>
      <Complaint />
    </template>
  </Paywall>
</template>

<script>
import { mapState } from 'vuex'

import TaskTable from '@/components/Task/Table/Component'
import { Paywall } from '@/components/Upsell'
import { AlertComponent as Alert } from 'vue-elder-alert'
import HelperPopover from '@/components/HelperPopover/Component'
import Complaint from '@/components/Task/Complaint/Component'
import Bus from '@/bus'

export default {
  computed: {
    ...mapState('ResidentialAccount', ['item']),
    addons(state) {
      return this.$path('item.reference.project.metadata.addons', state) || []
    },
    hasComplaintRole() {
      return Boolean(this.$path('item.reference.project.roles.complaint.manager.length'))
    },
  },
  methods: {
    addon(value) {
      return this.$store
        .dispatch('Project/addon', { addon: value, state: true, project: this.$path('item.reference.project.id') })
        .then(() => this.addons.push(value))
    },
    trigger() {
      Bus.$emit('complaint:show')
    },
  },
  components: {
    TaskTable,
    Paywall,
    Alert,
    HelperPopover,
    Complaint,
  },
}
</script>

<style lang="scss" scoped></style>
